import {
  Component,
  OnChanges,
  Input,
  SimpleChanges, OnInit, OnDestroy
} from "@angular/core";
import { DetailsConfig, SharedUiDetailsModule } from '@snelstart/ui-details';
import { ButtonConfiguration, SharedUiButtonModule } from '@snelstart/ui-button';
import {Observable, Subject, takeUntil} from "rxjs";
import {
  AllowanceEntity, BokkzAlgDataService, BokkzTslDataService,
  BokkzTslLogic, ClientEntity
} from "@snelstart-ventures/fiscaal/domain-logic";
import {ToastService} from "@snelstart/ui-toast";
import { VoorschotComponent } from '../toeslagen/voorschot/voorschot.component';
import { InkomenComponent } from '../toeslagen/inkomen/inkomen.component';
import { PartnerComponent } from '../toeslagen/partner/partner.component';
import { KinderenComponent } from '../toeslagen/kinderen/kinderen.component';
import { KinderopvangtoeslagComponent } from '../toeslagen/kinderopvangtoeslag/kinderopvangtoeslag.component';
import { HuurtoeslagComponent } from '../toeslagen/huurtoeslag/huurtoeslag.component';
import { BerekeningComponent } from '../toeslagen/berekening/berekening.component';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { TekstAanvragerComponent } from '../toeslagen/toelichtigen-tekst/tekst-aanvrager/tekst-aanvrager.component';
import { TekstPartnerComponent } from '../toeslagen/toelichtigen-tekst/tekst-partner/tekst-partner.component';
import { TekstKinderenComponent } from '../toeslagen/toelichtigen-tekst/tekst-kinderen/tekst-kinderen.component';
import {
  TekstKinderopvangComponent
} from '../toeslagen/toelichtigen-tekst/tekst-kinderopvang/tekst-kinderopvang.component';
import {
  TekstHuurtoeslagComponent
} from '../toeslagen/toelichtigen-tekst/tekst-huurtoeslag/tekst-huurtoeslag.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tax-allowance-details',
  templateUrl: './feature-tax-allowance-details.component.html',
  styleUrls: ['./feature-tax-allowance-details.component.scss'],
  imports: [
    SharedUiButtonModule,
    SharedUiDetailsModule,
    InkomenComponent,
    PartnerComponent,
    KinderenComponent,
    KinderopvangtoeslagComponent,
    HuurtoeslagComponent,
    BerekeningComponent,
    SharedUiDialogModule,
    TekstPartnerComponent,
    TekstKinderopvangComponent,
    TekstHuurtoeslagComponent,
    TekstKinderenComponent,
    TekstAanvragerComponent,
    VoorschotComponent,
    CommonModule
  ],
})
export class FeatureTaxAllowanceDetailsComponent implements OnInit, OnChanges, OnDestroy {

  @Input() public id!: string;
  private destroy$ = new Subject<void>();
  public clientEntity = {} as ClientEntity;
  public allowanceEntity = {} as AllowanceEntity;
  public dialogInfoVisible = false;

  public detailsConfig = DetailsConfig.create({
    hideArrowButtons: true,
  });

  constructor(
    public bokkzTslLogic: BokkzTslLogic,
    public bokkzTslDataService: BokkzTslDataService,
    private dataAlgService: BokkzAlgDataService,
    public toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.dataAlgService.client.pipe(takeUntil(this.destroy$)).subscribe((client) => {
        this.clientEntity = client;
      },
    );
    this.bokkzTslDataService.allowanceEntity.pipe(takeUntil(this.destroy$)).subscribe((allowanceEntity) => {
      this.allowanceEntity = allowanceEntity;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const idChanges = changes['id'];
    if (idChanges && idChanges.currentValue !== idChanges.previousValue) {
      this.id = idChanges.currentValue;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public config() {
    return ButtonConfiguration.create({
      onClick: () =>
        new Observable((subscription) => {
          setTimeout(() => {
            subscription.next(true);
            subscription.complete();
            this.saveForm();
          }, 200);
        }),
    });
  }

  public showButtonOpslaan(id: string): boolean {
    const toegestaneIds: string[] = ['Berekening'];
    return toegestaneIds.includes(id);
  }

  public showButtonInfo(id: string): boolean {
    const toegestaneIds: string[] = [
      'Aanvrager',
      'Partner',
      'Kinderen',
      'Huurwoning',
      'Kinderopvang',
    ];
    return toegestaneIds.includes(id);
  }

  public showDialogInfo() {
    this.dialogInfoVisible = true;
  }

  public saveForm(): void {
    setTimeout(() => {
      this.bokkzTslLogic.postAllowances(this.clientEntity.sstRelationId!, this.allowanceEntity, false);
    }, 0);
  }
}
